webpackJsonp([200057202546481],{

/***/ 1820:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/news/introducing-sophie-baldwin/"},"frontmatter":{"title":"Introducing... Sophie Baldwin","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1160x450 introducing sophie baldwin article header-d2f7e935d5f333236b87bb6da17a48b8.jpg"}}},"original":"/img/1160x450 introducing sophie baldwin article header.jpg"},"category":"Culture"}}}]}},"pathContext":{"tag":"Introducing to RLA"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-introducing-to-rla-7afe291c7f09d3f10173.js